import src from "IMAGE";
export default { src, width: 416, height: 151, blurWidth: 0, blurHeight: 0};
